import {
  LinearProgress,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import NoRowOverlay from "../../../assets/images/icons/NoRowOverlay";
import {
  StyledDataGrid,
} from "../../../components/StyledComponents";
import CustomPagination from "../CustomPagination";
import { useAuth } from "../../../context/AuthContext";
import { generateTranslateMuiTable } from "../../../utils/Function/commonFunction";
import { useLoading } from "../../../context/LoadingContext";
import CustomColumnsPanel from "../../../components/CustomColumnsPanel";

const GroupAdminGridInfoTable = ({
  selectedRows,
  refreshData,
  handleRefreshTable,
  refreshInfo,
  adminGroup,
  userData
}) => {
  const { t, i18n } = useTranslation();
  const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
  // const language = useSelector((state) => state.languageR.language);

  const adminRows = useMemo(() => {
    return adminGroup.map((admin) => {
      const user = userData.find(
        (u) => Number(u.userId) === Number(admin.userId)
      );

      return {
        ...admin,
        fullName: user?.fullName || "-",
        email: user?.email || "-",
      };
    });
  }, [adminGroup, userData]);

  const columnData = useMemo(
    () => [
      {
        field: "fullName",
        headerName: t("common.full-name"),
        minWidth: 240,
        flex: 1.5,
      },
      { field: "email", headerName: "Email", minWidth: 220, flex: 1.4 },
      {
        field: "permission",
        headerName: t("common.writePermission"),
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          switch (params.row.permission) {
            case 1:
              return t("common.all");
            case 2:
              return t("common.writeonly");
            case 3:
              return t("common.readonly");
            default:
              return "-";
          }
        }
      }
    ],
    [t, adminGroup]
  );

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    employeeCode: true,
    fullName: true,
    email: true,
    phone: true,
    createdAt: true,
    // modifiedTime: false,
    // isAdmin: false,
    // isActive: false,
  });
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [gridLoading, setGridLoading] = useState(false);
  const [filteredRowData, setFilteredRowData] = useState([]);
  const [filteredRowCount, setFilteredRowCount] = useState(0);
  const [rowCount, setRowCount] = useState(0);

  const handleRowsPerPageChange = (newPageSize) => {
    // newPageSize ở đây tuỳ CustomPagination, có thể là event hoặc number
    const size =
      typeof newPageSize === "number"
        ? newPageSize
        : parseInt(newPageSize.target.value, 10);

    setPage((prevPage) => {
      // index của record đầu tiên đang xem
      const firstRowIndex = prevPage * pageSize;

      // page mới sao cho vẫn chứa record đó
      const newPage = Math.floor(firstRowIndex / size);

      // phòng trường hợp vượt quá số trang
      const maxPage = Math.max(
        0,
        Math.ceil(rowCount / size) - 1
      );

      return Math.min(newPage, maxPage);
    });

    setPageSize(size);
  };

  return (
    <div>
      <div className="mt-2">
        <StyledDataGrid
          sx={{
            height: selectedRows?.id === 1 ? "68vh" : "64vh",
            // height: 320,
            "& .MuiDataGrid-scrollbar--vertical, & .MuiDataGrid-scrollbar--horizontal":
            {
              display: "none !important",
            },

            /* KHÔNG chừa chỗ cho scrollbar nữa */
            "& .MuiDataGrid-scrollbarFiller": {
              display: "none !important",
            },
            "& .MuiDataGrid-columnHeaders": {
              paddingRight: 0,
            },
            "& .MuiDataGrid-topContainer": {
              paddingRight: 0,
            },

            "&": {
              "--DataGrid-scrollbarSize": "0px",
            },

            "& .MuiDataGrid-virtualScroller": {
              scrollbarWidth: "none",
            },
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
              width: 0,
              height: 0,
            },
            "&:hover .MuiDataGrid-virtualScroller, &:focus-within .MuiDataGrid-virtualScroller":
            {
              scrollbarWidth: "thin",
            },
            "&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar, &:focus-within .MuiDataGrid-virtualScroller::-webkit-scrollbar":
            {
              width: 10,
              height: 10,
            },

            '& [class*="MuiDataGrid-scrollbar"][class*="--horizontal"]': {
              display: "none !important",
            },
            "& input[type=number]": {
              textAlign: "center",
              MozAppearance: "textfield",
              WebkitAppearance: "none",
              padding: "5px !important",
              height: "100%",
              pointerEvents: "none",
              caretColor: "transparent",
              userSelect: "none",
              paddingTop: "8px !important",
              paddingBottom: "8px !important"
            },
          }}
          rows={adminRows}
          columns={columnData}
          loading={gridLoading}
          rowCount={adminRows.length}
          slots={{
            pagination: CustomPagination,
            loadingOverlay: LinearProgress,
            noRowsOverlay: NoRowOverlay,
            columnsPanel: CustomColumnsPanel,
          }}
          slotProps={{
            pagination: {
              page,
              count: adminRows.length,
              rowsPerPage: pageSize,
              onPageChange: setPage,
              onRowsPerPageChange: handleRowsPerPageChange,
            },
          }}
          localeText={tableTranslated}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
        />
      </div>
    </div>
  );
};

export default GroupAdminGridInfoTable;
